module.exports = __webpack_public_path__ + "img/local_offer_white_48dp.d3b28ff2.svg";